<template>
  <div>
    <div class="text-center q-pa-xs">
      <img :src="quote.image" style="max-width: 200px" />
    </div>
    <div class="quote q-px-md q-pt-sm q-pb-md q-mb-sm">
      <h5 class="q-pb-xs" style="color: #616161">Quote Summary</h5>
      <QList>
        <QItem>
          <QItemSection>Quote ID:</QItemSection>
          <QItemSection class="value">{{ quote.id }}</QItemSection>
        </QItem>
        <QItem>
          <QItemSection>Vehicle Make:</QItemSection>
          <QItemSection class="value">{{ quote.make }}</QItemSection>
        </QItem>
        <QItem>
          <QItemSection>Model:</QItemSection>
          <QItemSection class="value">{{ quote.model }}</QItemSection>
        </QItem>
        <!-- <QItem>
          <QItemSection>Year:</QItemSection>
          <QItemSection class="value">{{ quote.year }}</QItemSection>
        </QItem> -->
        <QItem>
          <QItemSection>Price:</QItemSection>
          <QItemSection class="value">{{ quote.price }}</QItemSection>
        </QItem>
        <QItem>
          <QItemSection>Lease Term:</QItemSection>
          <QItemSection class="value">{{ quote.term }}</QItemSection>
        </QItem>
      </QList>
    </div>
  </div>
</template>

<script>
import { QList, QItem, QItemSection } from 'quasar';
/**
 * This component represents common UI for displaying the status in the progress list
 */
export default {
  name: 'QuoteSummary',
  props: {
    quote: Object
  },
  components: { QList, QItem, QItemSection }
};
</script>

<style lang="sass" scoped>
.quote
 background-color: $primary-background;
.q-item
  padding: 2px 0;
  min-height: 0px;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
.value
  max-width: 40%;
  color: #0C2645;
  font-weight: 500;
</style>
